import "./styles.scss";

import { AppContainer, PoolResults } from "../../components";

export const PoolDetail = () => {
  const parseStorage = (key, fallback = null) => {
    try {
      const value = localStorage.getItem(key);
      return value ? JSON.parse(value) : fallback;
    } catch (_) {
      return fallback;
    }
  };

  const poolMatches = parseStorage("matches", []);
  const userMatches = parseStorage("userMatches", []);
  const userName = localStorage.getItem("userName");

  const createPool = () => {
    const matches = verifyResult();

    return matches.map((match, index) => {
      return (
        <div
          className={`${
            match.success === null ? "" : match.success ? "winner" : "loser"
          } match`}
          key={index}>
          <PoolResults match={match} disable result={match.success} />
        </div>
      );
    });
  };

  const getTotal = () => {
    const matches = verifyResult();
    const total = matches.filter((match) => match.success === true);
    return `Total: ${total.length}`;
  };

  const verifyResult = () => {
    let matches = [];

    if (!Array.isArray(userMatches) || !Array.isArray(poolMatches)) return matches;

    userMatches.forEach((userMatch) => {
      const comparative = poolMatches.filter(
        (poolMatch) =>
          poolMatch.localTeam === userMatch.localTeam &&
          poolMatch.visitTeam === userMatch.visitTeam
      );

      let matchesResult;
      const comparativeMatch = comparative[0];

      if (!comparativeMatch) {
        matches.push({
          ...userMatch,
          success: null,
        });
        return;
      }

      if (
        comparativeMatch.result === null ||
        comparativeMatch.result === undefined
      ) {
        matchesResult = {
          ...userMatch,
          success: null,
        };
      } else {
        const success = comparativeMatch.result === userMatch.result;
        matchesResult = {
          ...userMatch,
          success,
        };
      }

      matches.push(matchesResult);
    });

    return matches;
  };

  return (
    <AppContainer>
      <div className='pool-detail-container'>
        <span className='title'>{userName}</span>
        <div className='matches-container'>{createPool()}</div>
        <span className='title'>{getTotal()}</span>
      </div>
    </AppContainer>
  );
};
